import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-scroll-to-top-partial',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './scroll-to-top-partial.component.html',
  styleUrls: ['./scroll-to-top-partial.component.scss'],
})
export class ScrollToTopPartialComponent implements OnInit, OnDestroy {
  constructor() {
    console.log('ScrollToTopPartialComponent constructor');
  }

  ngOnInit(): void {
    console.log('ScrollToTopPartialComponent ngOnInit');
  }

  ngOnDestroy(): void {
    console.log('ScrollToTopPartialComponent ngOnDestroy');
  }

  public scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
